import { IconProp, RotateProp } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import styles from "./JobCompletionBadge.module.scss"
import { JobCompletionBadgeProps } from "./JobCompletionBadge.types"

interface CompletionVisual {
    icon: IconProp
    iconClassName: string
    iconRotation?: RotateProp
}

// The pie-style icon fills up as the series progresses, turning green once complete.
function getCompletionVisual(percentage: number): CompletionVisual {
    if (percentage >= 100) {
        return { icon: faIcon({ name: "circle-check", style: "solid" }), iconClassName: styles.complete }
    }
    if (percentage >= 67) {
        return {
            icon: faIcon({ name: "circle-three-quarters-stroke", style: "solid" }),
            iconClassName: styles.inProgress,
            iconRotation: 270,
        }
    }
    if (percentage >= 34) {
        return {
            icon: faIcon({ name: "circle-half-stroke", style: "solid" }),
            iconClassName: styles.inProgress,
            iconRotation: 180,
        }
    }
    if (percentage >= 1) {
        return {
            icon: faIcon({ name: "circle-quarter-stroke", style: "solid" }),
            iconClassName: styles.inProgress,
            iconRotation: 90,
        }
    }
    return { icon: faIcon({ name: "circle-dashed", style: "solid" }), iconClassName: styles.empty }
}

export default function JobCompletionBadge(props: JobCompletionBadgeProps) {
    const { completed, total, size = "md" } = props

    if (!total) {
        return null
    }

    const percentage = Math.round((completed / total) * 100)
    const { icon, iconClassName, iconRotation } = getCompletionVisual(percentage)

    // e.g. "Completed 60%\n6 of 10 jobs".
    const tooltip = `Completed ${percentage}%\n${completed} of ${total} jobs`

    return (
        <Badge
            size={size}
            variant="icon"
            icon={icon}
            iconClassName={iconClassName}
            iconRotation={iconRotation}
            tooltip={tooltip}
        >
            {`${completed}/${total}`}
        </Badge>
    )
}
